class MFooter extends HTMLElement{constructor(){super(),this.init()}init(){const e=this.querySelector(".m-footer--accordion"),t=document.querySelector(".m-mobile-sticky-bar");e&&(MinimogTheme.config.mqlMobile&&(this.acc=new MinimogLibs.Accordion(e,{presetContentHeight:!0,onload:!0})),document.addEventListener("matchMobile",(()=>{this.acc=new MinimogLibs.Accordion(e,{presetContentHeight:!0,onload:!0})}))),t&&(document.documentElement.style.setProperty("--mobile-sticky-bar-height",`${t.offsetHeight}px`),document.addEventListener("matchMobile",(()=>{document.documentElement.style.setProperty("--mobile-sticky-bar-height",`${t.offsetHeight}px`)})),document.addEventListener("unmatchMobile",(()=>{document.documentElement.style.setProperty("--mobile-sticky-bar-height",`${t.offsetHeight}px`)})))}}customElements.define("m-footer",MFooter);

document.addEventListener('DOMContentLoaded', function() {
    // Define the image URLs
    var images = [
        'https://cdn.shopify.com/s/files/1/0568/6840/5406/files/icon-nav-shop.png?v=1764598466', 
        'https://cdn.shopify.com/s/files/1/0568/6840/5406/files/icon-nav-mens.png?v=1710777268', 
        'https://cdn.shopify.com/s/files/1/0568/6840/5406/files/icon-nav-womens.jpg?v=1710777271',
        'https://cdn.shopify.com/s/files/1/0568/6840/5406/files/icon-nav-kids.jpg?v=1710777274',
        'https://cdn.shopify.com/s/files/1/0568/6840/5406/files/icon-nav-hard-goods.jpg?v=1710777437',
        'https://cdn.shopify.com/s/files/1/0568/6840/5406/files/icon-nav-collabs.jpg?v=1710779651',
        'https://cdn.shopify.com/s/files/1/0568/6840/5406/files/icon-nav-about.jpg?v=1710777280',
        'https://cdn.shopify.com/s/files/1/0568/6840/5406/files/icon-nav-rentals.jpg?v=1710779850',
        'https://cdn.shopify.com/s/files/1/0568/6840/5406/files/icon-nav-community_41a2adaf-89f1-4a13-9623-a0bedbdf82d5.jpg?v=1710779839'
    ];

    // Iterate over each image URL
    images.forEach(function(url, index) {
        // Create a new img element for each URL
        var img = document.createElement('img');
        img.src = url;
        img.style.maxWidth = '30px'; // Apply the max-width style

        // Select the nth-child of .m-menu-mobile li based on the current index
        var target = document.querySelector('.m-menu-mobile li:nth-child(' + (index + 1) + ')');
        if (target) {
            // Insert the img element at the beginning of the container
            target.insertBefore(img, target.firstChild);
        }
    });
});
